"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var text_1 = require("../base/text");
var InputSize;
(function (InputSize) {
    InputSize["Small"] = "small";
    InputSize["Medium"] = "medium";
    InputSize["Large"] = "large";
})(InputSize = exports.InputSize || (exports.InputSize = {}));
var InputType;
(function (InputType) {
    InputType["Error"] = "error";
    InputType["Warning"] = "warning";
    InputType["Success"] = "success";
})(InputType = exports.InputType || (exports.InputType = {}));
exports.InputWrapper = function (_a) {
    var _b;
    var children = _a.children, type = _a.type, message = _a.message, onlyChildren = _a.onlyChildren, _c = _a.passive, passive = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "small" /* Small */ : _d, _e = _a.label, label = _e === void 0 ? '' : _e, _f = _a.note, note = _f === void 0 ? '' : _f;
    var fontSize = size === "large" /* Large */ ? "ty-font-md" /* Medium */ : "ty-font-sm" /* Small */;
    var hasInputType = type !== undefined;
    var inputClassName = classnames_1.default('ty-input-w', (_b = {
            'ty-input-passive': passive
        },
        _b["ty-input-" + type] = hasInputType,
        _b));
    var messageColor = type === "error" /* Error */ ? "ty-color-red" /* Red */ : type === "warning" /* Warning */ ? "ty-color-orange" /* Orange */ : type === "success" /* Success */ ? "ty-color-green" /* Green */ : "ty-color-black" /* Black */;
    return (React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-column" /* Column */, fontSize: fontSize, color: "ty-color-black" /* Black */, className: inputClassName }, onlyChildren ? (children) : (React.createElement(React.Fragment, null,
        label && (React.createElement(text_1.Text, { elementType: "label" /* Label */, fontWeight: "ty-font-w-bold" /* Bold */, margin: "ty-mgb-1" /* One */ }, label)),
        children,
        React.createElement(styledLayout_1.StyledLayout, { margin: "ty-mgt-1" /* One */, display: "ty-display-flex" /* Flex */ },
            React.createElement(text_1.Text, { fontWeight: "ty-font-w-bold" /* Bold */, color: messageColor, fontSize: "ty-font-sm" /* Small */ }, message),
            React.createElement(text_1.Text, { color: "ty-color-soft-gray" /* SoftGray */, margin: "ty-mgl-auto" /* Auto */, fontSize: "ty-font-sm" /* Small */ }, note))))));
};
